import React, { useState, useEffect } from "react";
import moment from "moment";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "antd";

export default function JitsiMeetUser(props) {
  const { product, type } = props;
  const [isMeetingTime, setIsMeetingTime] = useState(false);
  const [jwtToken, setJwtToken] = useState("");
  const [roomName, setRoomName] = useState(
    product.meta_data?.find((meta) => meta.meta_key === "meet_jitsi")
      ?.meta_value
  );
  const user = useSelector((state) => state.user.user);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchMeetingData = async () => {
      try {
        if (product) {
          let startTime, endTime, eventDate;

          if (type === "event") {
            const startTimeMeta = product.meta_data.find(
              (meta) => meta.meta_key === "event_starttime"
            );
            const endTimeMeta = product.meta_data.find(
              (meta) => meta.meta_key === "event_endtime"
            );
            const eventDateMeta = product.meta_data.find(
              (meta) => meta.meta_key === "event_date"
            );

            if (startTimeMeta && endTimeMeta && eventDateMeta) {
              startTime = `${eventDateMeta.meta_value.split(" ")[0]} ${
                startTimeMeta.meta_value
              }`;
              endTime = `${eventDateMeta.meta_value.split(" ")[0]} ${
                endTimeMeta.meta_value
              }`;
              eventDate = eventDateMeta.meta_value.split(" ")[0];
            }
          } else if (type === "appointment") {
            if (product && product.start_time) {
              startTime = moment
                .utc(product.start_time)
                // .add(4, "hours")
                .format("YYYY-MM-DD HH:mm:ss");

              if (product.service && product.service.meta_data) {
                const durationMeta = product.service.meta_data.find(
                  (meta) => meta.meta_key === "service_duration_time"
                );

                if (durationMeta) {
                  const duration = moment.duration(durationMeta.meta_value);
                  endTime = moment(startTime)
                    .add(duration)
                    .format("YYYY-MM-DD HH:mm:ss");
                }
              }

              eventDate = moment.utc(product.start_time).format("YYYY-MM-DD");
            }
          }

          if (startTime && endTime && eventDate) {
            // const eventStartDateTime = moment(
            //   `${eventDate} ${startTime}`,
            //   "YYYY-MM-DD HH:mm:ss"
            // );
            // const eventEndDateTime = moment(
            //   `${eventDate} ${endTime}`,
            //   "YYYY-MM-DD HH:mm:ss"
            // );

            const eventStartDateTime = moment(
              `${startTime}`,
              "YYYY-MM-DD HH:mm:ss"
            );
            const eventEndDateTime = moment(
              `${endTime}`,
              "YYYY-MM-DD HH:mm:ss"
            );

            const now = moment();

            if (eventStartDateTime.isValid() && eventEndDateTime.isValid()) {
              const minutesToStart = moment
                .duration(eventStartDateTime.diff(now))
                .asMinutes();
              const minutesToEnd = moment
                .duration(eventEndDateTime.diff(now))
                .asMinutes();

              if (minutesToStart <= 30 && minutesToEnd >= 0) {
                setIsMeetingTime(true);
              } else {
                setIsMeetingTime(false);
              }
            }
          }

          if (!jwtToken) {
            getJWT();
          }
        }
      } catch (error) {
        console.error("Error fetching meeting data:", error);
      }
    };

    fetchMeetingData();
  }, [product, type, jwtToken]);

  if (!product) {
    return <div>Loading...</div>;
  }

  const getJWT = async () => {
    const APIURL = `/api/jitsi-meet/accessAuthClient`;

    console.log("product", product);
    console.log("user", user);

    const eventData = {
      id: type === "event" ? product.event_id : product.id,
      owner_id:
        type === "event" ? product.event[0].owner_id : product.service.id,
    };

    try {
      const res = await axiosWithAuth().post(APIURL, {
        roomName: product.meta_data.find(
          (meta) => meta.meta_key === "meet_jitsi"
        )
          ? product.meta_data.find((meta) => meta.meta_key === "meet_jitsi")
              .meta_value
          : "default",
        user: {
          id: user.id,
          name: user.user_fname,
          email: user.user_email,
        },
        eventData: eventData,
        typeEvent: type === "event" ? "event" : "appointment",
      });
      setJwtToken(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleButtonClick = () => {
    navigate(`/jitsi-meet/${roomName}`, {
      state: { jwtToken, roomName, type: "user" },
    });
  };

  const handleJitsiServerButtonClick = () => {
    const domain = process.env.REACT_APP_JITSI_DOMAIN;
    console.log("roomName", roomName);
    console.log("jwtToken", jwtToken);
    if (roomName && jwtToken) {
      const jitsiServerURL = `https://${domain}/${roomName}?jwt=${jwtToken}`;
      window.open(jitsiServerURL, "_blank");
    } else {
      console.error("Room name or JWT token is missing");
    }
  };

  return (
    <div>
      <button
        onClick={() => handleJitsiServerButtonClick()}
        disabled={!isMeetingTime}
      >
        <Tooltip title="Join Meeting">
          <FontAwesomeIcon icon={faVideo} />
        </Tooltip>
      </button>
    </div>
  );
}
